import * as preact from "preact";

const icons = {
  home: <path d="m3 10 9-7 9 7M5 9v12h5v-7h4v7h5V9" />,
  library: (
    <path d="M7 3h13v18H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3ZM4 17h16M9 7h6M9 11h4" />
  ),
  discover: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" />
    </>
  ),
  words: (
    <>
      <path d="M8 6h13M8 12h13M8 18h13" />
      <g fill="currentColor" stroke="none">
        <circle cx="3" cy="6" r="1.2" />
        <circle cx="3" cy="12" r="1.2" />
        <circle cx="3" cy="18" r="1.2" />
      </g>
    </>
  ),
  practice: (
    <>
      <path d="M17 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h2" />
      <rect x="7" y="7" width="14" height="14" rx="2" />
      <path d="M11 12h6M11 16h4" />
    </>
  ),
};

export default class NavigationIcon extends preact.Component<{
  name: keyof typeof icons;
}> {
  render() {
    return (
      <svg
        class="navigationIcon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        {icons[this.props.name]}
      </svg>
    );
  }
}
